/**
 * Central catalog of main product/service pages, keyed by id.
 * Used by CategoryTemplate's "関連サービス" section on each page.
 */
export const SERVICE_CATALOG = {
  'signage': {
    id: 'signage',
    label: 'SIGN DESIGN',
    name: '看板・サイン',
    desc: '店舗看板・施設サイン・案内表示までデザインから施工まで。',
    to: '/products/signage',
    image: '/images/services/signage.png',
  },
  'led-lighting': {
    id: 'led-lighting',
    label: 'LED LIGHT',
    name: 'LED照明',
    desc: '店舗・施設・屋外空間の照明を、省エネと視認性まで含めて提案。',
    to: '/products/led-lighting',
    image: '/images/services/led-lighting.png',
  },
  'led-vision': {
    id: 'led-vision',
    label: 'LED VISION',
    name: 'LEDビジョン',
    desc: '屋内外の映像演出・広告表示に対応するLEDディスプレイ。',
    to: '/products/led-vision',
    image: '/images/services/led-vision.png',
  },
  'electric-board': {
    id: 'electric-board',
    label: 'ELECTRIC BOARD',
    name: '電光掲示板',
    desc: '案内・誘導・注意喚起など、目的別の電光掲示板をカスタム製作。',
    to: '/products/electric-board',
    image: '/images/services/electric-board.png',
  },
  'security-camera': {
    id: 'security-camera',
    label: 'SECURITY CAMERA',
    name: '防犯カメラ',
    desc: '店舗防犯から工場・広域施設まで、統合的な監視構成に対応。',
    to: '/products/security-camera',
    image: '/images/services/security-camera.png',
  },
  'parking-system': {
    id: 'parking-system',
    label: 'PARKING SYSTEM',
    name: 'パーキングシステム',
    desc: '満空表示・料金表示・出入口設備まで、駐車場運営を支える一式。',
    to: '/products/parking-system',
    image: '/images/services/parking.png',
  },
  'emergency-board': {
    id: 'emergency-board',
    label: 'EMERGENCY BOARD',
    name: '緊急出動警報板',
    desc: '消防・警察・特殊施設向けの出動警報表示。運用連動まで対応。',
    to: '/products/emergency-board',
    image: '/images/services/emergency-board.png',
  },
  'custom-metal': {
    id: 'custom-metal',
    label: 'CUSTOM METAL',
    name: 'カスタム金物製作',
    desc: '看板・カメラ・LED架台など、現場合わせの特注金物を設計・製作。',
    to: '/products/custom-metal',
    image: '/images/services/custom-metal.png',
  },
};

export const getRelated = (ids) => ids.map((id) => SERVICE_CATALOG[id]).filter(Boolean);
